import { render, staticRenderFns } from "./preview-email.vue?vue&type=template&id=b5d8271e&"
import script from "./preview-email.vue?vue&type=script&lang=js&"
export * from "./preview-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports